import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box, Grid, Modal } from '@mui/material';
import { CLEAR_DATA, SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';
import { DELETE_COMPANY, DELETE_TEAM_MEMBER } from 'schemas/mutation';
import { setReload } from 'store/MyTeam/types';
import { setIsLoggedIn } from 'store/Authentication/actions';

function DeleteCompany(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { modalOpen, setModalOpen } = props;
    const customization = useSelector((params) => params.customization);
    const authentication = useSelector((params) => params.authentication);
    const companyId = customization.companyData._id;
    const companyList = authentication.companyList;

    const closeModal = () => {
        setModalOpen(false);
    };
    const [deleteCompany, { data: deletedResponse }] = useMutation(DELETE_COMPANY, {
        onError: (error) => {
            dispatch({ type: SET_LOADING, loading: false });
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: 'Something went wrong while trying to delete company.'
                }
            });
        }
    });

    useEffect(async () => {
        if (deletedResponse) {
            setModalOpen(false);
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'success',
                    message: deletedResponse.removeCompany.message
                }
            });
            dispatch({ type: SET_LOADING, loading: false });
            const userData = localStorage.getItem('diologUserData');
            const userDataParsed = JSON.parse(userData);
            delete userDataParsed.companyId;
            localStorage.setItem('diologUserData', JSON.stringify(userDataParsed));
            if (companyList.length == 2) {
                let newCompanyId = companyList.filter((x) => x._id != companyId);
                const userData = localStorage.getItem('diologUserData');
                const userDataParsed = JSON.parse(userData);
                userDataParsed.companyId = newCompanyId[0]._id;
                localStorage.setItem('diologUserData', JSON.stringify(userDataParsed));
                navigate('/dashboard');
                window.location.reload();
            } else if (companyList.length > 2) {
                navigate('/');
            } else {
                localStorage.removeItem('diologAuthToken');
                localStorage.removeItem('diologRefToken');
                localStorage.removeItem('diologUserData');
                dispatch({ type: CLEAR_DATA });
                dispatch({ type: setIsLoggedIn, isLoggedIn: false });
                navigate('/');
            }
        }
    }, [deletedResponse]);

    const handleDeleteCompany = async () => {
        dispatch({ type: SET_LOADING, loading: true });
        await deleteCompany({
            variables: {
                removeCompanyInput: {
                    id: companyId
                }
            }
        });
    };
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24
    };
    return (
        <>
            <Modal open={modalOpen} onClose={closeModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style} className="modal-box">
                    <Box className="modal-hero">
                        <img src={AnnouncementImage} alt="announcement" />
                    </Box>
                    <Box className="modal-body">
                        <Typography variant="h2" component="h2">
                            Are you sure you want to delete this?
                        </Typography>
                    </Box>
                    <Box className="modal-footer pt-0">
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Button variant="outlined" className="alternate-reversed w-full" onClick={closeModal}>
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button variant="contained" className="alternate w-full" onClick={handleDeleteCompany}>
                                    Delete
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}

export default DeleteCompany;
